export default __webpack_public_path__ + "static/media/Green_Glasses.6c762bdf.jpg";